import api from './api';

export const fornitoriGetCentro = (cantiereId) =>
  api.get(`/fornitori/centro/${cantiereId}`);

export const fornitoriSaveCentro = (cantiereId, centro) =>
  api.post(`/fornitori/centro/${cantiereId}`, { centro_costo: centro });

export const fornitoriFetch = (cantiereId, refresh = false) =>
  api.get(`/fornitori/${cantiereId}${refresh ? '?refresh=true' : ''}`);
